import { GraphQLResult, generateClient } from 'aws-amplify/api';
import config from './config';

function fetchWithAuthorization<TData, TVariables>(endpoint: string, requestInit: RequestInit, query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const requestInitWithAuth = {
      ...requestInit,
      headers: {
        ...requestInit.headers,
        Authorization: document.cookie,
      },
    };
    const res = await fetch(endpoint, {
      method: 'POST',
      ...requestInitWithAuth,
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];
      throw new Error(message);
    }

    return json.data;
  };
}

const client = generateClient({
  authMode: 'userPool',
});

export function fetchCoreApi<TData, TVariables>(query: string, variables?: TVariables) {
  return fetchWithAuthorization<TData, TVariables>(config.AppSyncUrl ?? '', {}, query, variables);
}

export function fetchWithAmplify<TData, TVariables>(query: string, variables?: TVariables): (() => Promise<TData>) {
  return async () => {
    const result = await (client.graphql({
      query,
      variables: (variables || {} as any),
    }) as Promise<GraphQLResult<TData>>);
    if (result.errors) {
      const message = result.errors ? result.errors[0].message : 'GraphQL fetching error';
      throw new Error(message);
    }

    return result.data!;
  };
}
